module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Steven F. Havill\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Steven F. Havill lives with his wife of fifty-three years, Kathleen, in New Mexico. He is the author of thirty-two novels, taught secondary schools for 25 years, and recently earned an AAS degree in gunsmithing.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/6d24CA/tc-custom/9781615950768.jpg?1718072593905",
      "alt": "This image is the cover for the book Convenient Disposal, Posadas County Mysteries"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Convenient Disposal, Posadas County Mysteries\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Sheriff Estelle is called to teenager Carmen Acosta's home. When she arrives, Carmen's father, Freddie, is in police custody and an unconscious Carmen is on the way to the hospital \"beat to a pulp.\" There has been a fight over a boy, but it is hard to believe that the also young Deena is responsible. Estelle has many other suspects to choose from, since the Acosta family holds the record for the number of domestic violence calls the police have received. The question is, which of the other four children or two parents is responsible? Or is it someone else entirely?")]), _c('p', [_vm._v("Havill draws his readers into the life of this small border county in New Mexico. Estelle is not only an undersheriff, she is the mother of two delightful little boys, the wife of a warm and likeable surgeon, Mexican-American like herself, and the daughter of a wise old woman whose life has been spent south of the border. But the threats from Havill's fans would have been dire if he had dispensed with Billl Gastner, the dearly loved former sheriff. Bill may officially be retired, but he's quick to give Estelle the value of his experience when she needs it, and proud to have been chosen by the Guzman boys to be their surrogate "), _c('i', [_vm._v("abuelo")]), _vm._v("--grandfather.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Poisoned Pen Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0